import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=b52d4afa&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=b52d4afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_webpack@5.106.2__lodash@4.18.1_prettier@2.8.8_vue-t_4005a65e67acd77eac1bc9f1c137ca40/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52d4afa",
  null
  
)

export default component.exports